import { useTheme } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import PhotoCameraOutlinedIcon from "@material-ui/icons/PhotoCameraOutlined";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import React from "react";

import { RouteName } from "@/consts/RouteName";
import { Square } from "@/features/common/components/square/Square";
import { Text } from "@/features/common/components/tailwind/Text";
import { View } from "@/features/common/components/tailwind/View";
import { useSnackbar } from "@/features/common/hooks/snackbar/useSnackbar";
import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import {
  FeatureNameEnum,
  useCreatePostMutation,
} from "@/generated/generated-hooks";

import { createPostHelper } from "../helper";

export const EmptyPostPlaceholder: React.FC = (props) => {
  const theme = useTheme();
  const router = useRouter();
  const { t } = useTranslation("profilePublic");
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const { isEnabled } = useFeatureEnabled();
  const [createPost, { loading }] = useCreatePostMutation();
  const { openSnackbar } = useSnackbar();

  const onClick = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (loading) return;
    if (isEnabled(FeatureNameEnum.Nft)) {
      router.push(RouteName.ContentSelection);
      return;
    }
    createPostHelper({
      t,
      router,
      createPost,
      onClickLocation: smDown
        ? "mobileEmptyPlaceholder"
        : "desktopEmptyPlaceholder",
      openSnackbar,
    });
  };

  return (
    <>
      <View
        className="flex flex-col w-full relative border border-[#E0E0E0] rounded-xl overflow-hidden"
        style={{
          userSelect: "none",
          cursor: loading ? "default" : "pointer",
        }}
        onContextMenu={(e) => e.preventDefault()}
        onClick={onClick}
      >
        <Square>
          <View
            className="w-full h-full flex justify-center items-center"
            style={{ backgroundColor: theme.palette.grey[200] }}
          >
            <PhotoCameraOutlinedIcon
              style={{ color: "white", fontSize: 100 }}
            />
          </View>
        </Square>
        <View className="p-4 flex">
          <View className="flex-1">
            <Text size="normal">
              {t("profilePublic:emptyPostPlaceholderWording")}
            </Text>
          </View>
          <NavigateNextOutlinedIcon />
        </View>
      </View>
    </>
  );
};
